import { render, staticRenderFns } from "./PreGainsComponent.vue?vue&type=template&id=4467148b&"
import script from "./PreGainsComponent.vue?vue&type=script&lang=ts&"
export * from "./PreGainsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4467148b')) {
      api.createRecord('4467148b', component.options)
    } else {
      api.reload('4467148b', component.options)
    }
    module.hot.accept("./PreGainsComponent.vue?vue&type=template&id=4467148b&", function () {
      api.rerender('4467148b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/Gains/PreGainsComponent.vue"
export default component.exports